<template>
  <v-btn
    v-clipboard:copy="copiable"
    v-clipboard:success="
      (e) => {
        onCopy(e)
        $emit('copySuccess', e)
      }
    "
    v-clipboard:error="onError"
    v-bind="{ color, ...$props, ...$attrs }"
    x-small
    fab
    :aria-label="label"
    :title="label"
    v-tooltip="getTooltipHtml()"
    ><transition name="fade" mode="out-in"
      ><v-icon v-if="copied" x-small color="green" key="copied-check"
        >mdi-check</v-icon
      ><v-icon v-else x-small key="copy-clippy"
        >mdi-content-copy</v-icon
      ></transition
    ></v-btn
  >
</template>

<script>
export default {
  name: 'BtnCopiable',
  props: {
    label: {
      type: String,
      default: 'Copy',
    },
    copiable: {
      type: [String, Number],
      required: true,
    },
    color: {
      type: String,
      default: 'blue darken-2',
    },
    outlined: {
      type: Boolean,
      default: true,
    },
  },
  components: {},
  data() {
    return {
      copied: false,
    }
  },
  methods: {
    onCopy() {
      this.copied = true
      setTimeout(() => {
        this.copied = false
      }, 3000)
    },
    onError: function() {
      alert('Failed to copy the text to the clipboard')
    },
    getTooltipHtml() {
      return {
        content: this.copied
          ? '<div class="proxima--font">Copied!</div>'
          : `<div class="proxima--font font-italic">Click to copy</div>`,
        html: true,
        triggers: ['hover', 'click'],
      }
    }, // getTooltipHtml
  },
}
</script>
